<template>
  <div class="ee-banner" :style="style">
    <transition-group tag="div" name="slide" class="ee-banner__img-list" :style="style">
      <a class="ee-banner__img"
         v-for="banner,index in banners"
         :key="banner"
         v-show="show(index)"
         :href="banner.href"
         :style="imgStyle(banner.imgUrl)"
         target="_blank">
      </a>
    </transition-group>
    <div class="ee-banner__nav-bar">
      <span
        v-for="banner, index in banners"
        :class="{'is-active': index === cur}"
        @click="handlePause(index)"
        @mouseout="handleStart">
      </span>
    </div>
  </div>
</template>
<script>
  let timer = null
  export default {
    compName: 'ee-banner',
    props: {
      width: {
        type: [Number, String],
        default: '100%'
      },
      height: {
        type: Number,
        required: true
      },
      banners: {
        type: Array,
        required: true
      },
      interval: {
        type: Number,
        default: 3000
      }
    },
    data () {
      return {
        cur: 0
      }
    },
    computed: {
      style () {
        return {
          width: typeof this.width === 'string' ? this.width : `${this.width}px`,
          height: `${this.height}px`
        }
      }
    },
    methods: {
      show (index) {
        return index === this.cur
      },
      play () {
        if (timer) {
          clearInterval(timer)
        }
        timer = setInterval(() => {
          this.cur = (this.cur + 1) % this.banners.length
        }, this.interval)
      },
      handlePause (index) {
        if (timer) {
          clearInterval(timer)
        }
        this.cur = index
      },
      handleStart () {
        this.play()
      },
      imgStyle (imgUrl) {
        return {
          width: typeof this.width === 'string' ? this.width : `${this.width}px`,
          height: `${this.height}px`,
          backgroundImage: `url(${imgUrl})`
        }
      }
    },
    mounted () {
      timer = setInterval(() => {
        this.cur = (this.cur + 1) % this.banners.length
      }, this.interval)
    },
    destoryed () {
      if (timer) {
        clearInterval(timer)
      }
    }
  }
</script>
<style src="../style/banner.css"></style>



// WEBPACK FOOTER //
// src/packages/banner/Banner.vue?ea581220